import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';
import { Star, Clock, Users, MapPin, CheckCircle } from 'lucide-react';

const parksActivities = [
  {
    id: 4,
    title: "Aquaventure Waterpark",
    location: "Palm Jumeirah",
    price: "79.86",
    originalPrice: "95.00",
    duration: "Journée complète",
    groupSize: "Accès illimité",
    rating: 4.7,
    reviews: 3241,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
    badge: "Famille",
    highlights: ["Toboggans géants", "Plage privée", "Aquarium", "Restaurants inclus"],
    description: "Le plus grand parc aquatique du Moyen-Orient avec plus de 30 toboggans et attractions. Parfait pour toute la famille avec plage privée et aquarium géant."
  },
  {
    id: 9,
    title: "Wild Wadi Waterpark",
    location: "Jumeirah",
    price: "72.30",
    originalPrice: "88.00",
    duration: "Journée complète",
    groupSize: "Famille",
    rating: 4.8,
    reviews: 2134,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
    badge: "Famille",
    highlights: ["30 toboggans", "Plage artificielle", "Restaurants", "Zone enfants"],
    description: "Parc aquatique à thème avec 30 toboggans et attractions. Zone spéciale pour enfants, plage artificielle et restaurants sur place."
  }
];

export default function ParksActivitiesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-6 pb-8 bg-gradient-to-r from-cyan-600 to-blue-600 text-white relative">
        <div className="absolute inset-0 bg-[url('https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp')] bg-cover bg-center opacity-30"></div>
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <h1 className="text-4xl lg:text-5xl font-bold mb-2">Parcs d'Attractions</h1>
          <p className="text-lg text-cyan-50 max-w-2xl">Amusement garanti pour toute la famille</p>
        </div>
      </section>

      {/* Activities */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {parksActivities.map((activity) => (
              <div key={activity.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                <div className="relative overflow-hidden">
                  <img
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-cyan-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {activity.badge}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2">
                    <div className="text-right">
                      <div className="text-lg font-bold text-cyan-600">€{activity.price}</div>
                      <div className="text-sm text-gray-500 line-through">€{activity.originalPrice}</div>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center space-x-1">
                      <Star className="text-amber-400 fill-current" size={16} />
                      <span className="font-semibold text-gray-900">{activity.rating}</span>
                      <span className="text-gray-500 text-sm">({activity.reviews} avis)</span>
                    </div>
                    <div className="flex items-center text-gray-500 text-sm">
                      <MapPin size={14} className="mr-1" />
                      {activity.location}
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors">
                    {activity.title}
                  </h3>

                  <p className="text-gray-600 mb-4">{activity.description}</p>

                  <div className="flex items-center justify-between text-sm text-gray-600 mb-4">
                    <div className="flex items-center">
                      <Clock size={14} className="mr-1" />
                      {activity.duration}
                    </div>
                    <div className="flex items-center">
                      <Users size={14} className="mr-1" />
                      {activity.groupSize}
                    </div>
                  </div>

                  <div className="mb-6">
                    <div className="flex flex-wrap gap-2">
                      {activity.highlights.map((highlight, index) => (
                        <span key={index} className="bg-cyan-50 text-cyan-700 px-3 py-1 rounded text-sm">
                          <CheckCircle size={14} className="inline mr-1" />
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>

                  <Button className="w-full text-sm py-3">
                    Réserver maintenant
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

